<template>
  <div class="new-test">
    <form class="form-group" v-on:submit.prevent="addNewData">
      <p class="control">
        <input class="input is-medium" type="text" v-model="newBeer.boughtBy" placeholder="Inköpt av">
      </p>
      <p class="control">
        <input class="input is-medium" type="text" v-model="newBeer.name" placeholder="Namn på öl">
      </p>
      <p class="control">
        <input class="input is-medium" type="text" v-model="newBeer.brewery" placeholder="Bryggeri/producent">
      </p>
      <p class="control">
        <input class="input is-medium" type="text" v-model="newBeer.img" placeholder="Sökväg på bild från systemet">
          <span class="help">Kopiera den absoluta sövägen till den lilla bilden från listvyn och klistra in här.</span>
      </p>
      <p class="control">
        <input class="input is-medium" type="date" v-model="newBeer.date">
      </p>
      <p class="control">
        <input class="button is-medium is-primary" type="submit" value="Add new beer">
      </p>
    </form>
  </div>
</template>

<script>

export default {
  data () {
    return {
      newBeer: {
        name: '',
        brewery: '',
        boughtBy: '',
        img: '',
        id: '',
        date: this.today()
      }
    }
  },
  methods: {
    addNewData: function () {
      this.sanatize()
      this.newBeer.id = this.createId(this.newBeer.name)
      console.log(this.newBeer.id)
      this.$store.dispatch('createNewData', this.newBeer)
      this.newBeer.name = ''
      this.newBeer.brewery = ''
    },
    sanatize: function () {
      this.newBeer.name = this.newBeer.name.trim()
      this.newBeer.brewery = this.newBeer.brewery.trim()
      this.newBeer.boughtBy = this.newBeer.boughtBy.trim()
      this.newBeer.img = this.newBeer.img.trim()
    },
    today: function () {
      let now = new Date()
      now = now.toISOString().substring(0, 10)

      return now
    },
    createId: function (beerName) {
      beerName = beerName.replace(/\s+/g, '_').toLowerCase()
      beerName = beerName.replace(/[åä]/g, 'a')
      beerName = beerName.replace(/[ö]/g, 'o')
      beerName = beerName.replace(/[^a-z0-9_-]/g, '')

      return beerName
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// AddNew.vue?3f47e6b1